import React from 'react';
import PropTypes from 'prop-types';

import Dropdown from '@hydra/common/components/Dropdown';

export const FormDropdown = ({ disabled, value, onChange, items }) => {
  return (
    <Dropdown
      disabled={disabled}
      hasInput={false}
      onSelect={onChange}
      items={items}
      value={value}
    />
  );
};

FormDropdown.propTypes = {
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.string,
  items: PropTypes.array
};

export default FormDropdown;
